import React from 'react'
import './index.css'

const Loader = () => {
    return (
        <div>
            <div className="main-loader"/>
            <span className="loader"/>
        </div>
    )
};

export default Loader